<app-navigation></app-navigation>
<!-- Spacer to push content below the fixed nav (md:fixed kicks in at 768px).
     md nav height = h-16 (64px); lg desktop nav = h-16 pill + mt-4 + border mt-4 ≈ h-24 (96px) -->
<div class="hidden md:block h-16 lg:h-24"></div>
<router-outlet></router-outlet>
<app-cookie-banner></app-cookie-banner>
<app-footer></app-footer>
